export enum ESurveys {
  VOICE_AGENT = '019c08f8-9c53-0000-9bbb-1c956c169a12'
}
